<template>
    <div class="canvas">
        <div class="text-right" @click="goHome">返回首页<img src="../../assets/images/fanhui.svg" alt="" /></div>
        <div class="line"></div>
        <el-row>
            <el-col :span="6" v-for="(o, index) in cardList" :key="index" :offset="index > 0 ? 2 : 0">
                <el-card shadow="hover" @click.native="jumpOtherSys(o.path)" style="cursor:pointer">
                <div class="card"><img :src="o.img_url" class="image"></div>
                <div style="padding: 14px;">
                    <span>{{o.sname}}</span>
                    <div class="bottom clearfix">
                    </div>
                </div>
                </el-card>
            </el-col>
        </el-row>
        <div class="h-30"></div>
    </div>
</template>
<script>
import {
    getSelectAreaApi
} from "@/api"
export default {
  data () {
    return {
      cardList: []
    }
  },
  mounted(){
    this.searchArea()
  },
  methods: {
    /** 搜索查询专区 */
    async searchArea(params) {
        const { data } = await getSelectAreaApi(params)
        if (data) {
            this.cardList = data
        }
    },
    jumpOtherSys(path) {
        window.open(path, '_blank')
    },
    goHome(){
        this.$router.push({
          path: '/home'
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './SearchBlock.scss';

</style>
